import unescape from 'lodash/unescape';

const getString = (string, injections = null) => {
  let translation = string.split('.').reduce((obj, str) => obj?.[str], window?.theme?.strings);

  if (!translation) return `Missing translation for ${string} in window.Phill`;

  // Inject values into strings like, same format as translations (eg '{{ content }})
  if (injections) {
    translation = Object.entries(injections).reduce((str, [key, value]) => {
      const rx = new RegExp(`\\{{2}\\s*(${key})\\s*\\}{2}`, 'g');
      return str.replace(rx, value);
    }, translation);
  }

  return unescape(translation);
};

export default getString;
